<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_table_of_contents_1"><span>Author’s Note</span></p>
<p class="P_WFP_BodyTextFirstPara"><i>The Cadet</i> is a composite of over 60 years of Academy history, attempting to distill a wide spectrum of experiences that could not have possibly happened to just one cadet in a four-year period. And although this is a work of fiction, it is based on historical figures, events, and locations that are real; however, it is impossible to precisely reconstruct the thoughts and motivations of these historical figures and their actions. As such, the author has taken liberty to dramatically embellish historical events, and does not intend to denigrate—but only highlight and humanize—the significance of their actions. For example, George Delante did not exist; his actions did not occur. As another example, there was only one cadet squadron commander for Third Squadron in 1958; the fictional character portrayed is not related in any way to this person. In addition, only to dramatize the novel, some anecdotes may be out of chronological order or the venues changed (such as the CU mascot liberation; or the Class of 1959’s graduation ceremony being depicted on the parade field, instead of in Arnold Hall due to inclement weather; etc.). The sole purpose is not to make this novel a dry chronicle of historical fact, but rather to show the true excitement of establishing a major American landmark. Finally, there are a few terms and phrases used that may offend present day social mores, but these are only used to reflect the customs and social tones of a 1950s, post-Korean conflict, America.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0006.vue?ef3c897c